import './modules/copyright';
import './modules/header-scroll';
import './modules/company-map';
import './modules/solution-radar-chart';
import './modules/contact-form';